import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import SemesterModal from "./partials/SemesterModal";

import {
    getSemesters as onGetSemesters,
    addNewSemester as onAddNewSemester,
    updateSemester as onUpdateSemester,
    deleteSemester as onDeleteSemester,

} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const SemesterList = () => {

    //meta title
    document.title = "Semestres | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [semester, setSemester] = useState(null);
    



    const dispatch = useDispatch();

    const SemesterProperties = createSelector(
        (state) => state.semesterReducer, 
        (semesterReducer) => ({
            semesters: semesterReducer.semesters,
            loading: semesterReducer.loading
        })
    );

    const {semesters, loading} = useSelector(SemesterProperties);

    const [isLoading, setLoading] = useState(loading)




    useEffect(() => {
        if (semesters && !semesters.length) {
            dispatch(onGetSemesters());
        }

       
    }, [dispatch, semesters.length]);



   


    

  

    const toggle = () => {
        if (modal) {
            setModal(false);
            setSemester(null);
        } else {
            setModal(true);
        }
    };

    const handleSemesterClick = (semester) => {
        setSemester({
            id: semester.id,
            uid: semester.uid,
            name: semester.name,
            code: semester.code,
            is_active: semester.is_active,
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (semester) => {
        setSemester(semester);
        setDeleteModal(true);
    };

    const handleDeleteSemester = () => {
        if (semester && semester.id) {
            dispatch(onDeleteSemester(semester));
            setDeleteModal(false);
        }
    };

    const onClickNewSemester = () => {
        setIsEdit(false);
        setSemester(null);
        toggle();
        //setModal(true)
    };


    const handleFormSubmit = (values) => {
        // 1. On prépare les données à envoyer
        const payload = {
            id: values.id,
            uuid: values.uuid,
            name: values.name,
            code: values.code,
            is_active: values.is_active,
        };

        // 2. On dispatch l'action selon le mode (Edition ou Création)
        if (isEdit) {
            dispatch(onUpdateSemester(payload));
        } else {
            dispatch(onAddNewSemester(payload));
        }

        // 3. On ferme la modal et on réinitialise l'état local
        setModal(false);
        setSemester(null); 
    };



    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Nom",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Code",
                accessorKey: "code",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleSemesterClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteSemester}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Semestres" breadcrumbItem="Liste des semetres" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewSemester} className="btn btn-primary me-1">Ajouter un semestre</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={semesters || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"

                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    {/* Notre Nouvelle Modal Isolée */}
                    <SemesterModal 
                        isOpen={modal} 
                        toggle={toggle} 
                        isEdit={isEdit} 
                        semester={semester} 
                        onSubmit={handleFormSubmit} 
                    />
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default SemesterList;